<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/button";
import Input from "@/components/c-input";
import Search from "@/components/c-select-search";
import Area from "@/components/c-input-area";
import { propertyService } from "../../../services/propertyservice/property.service";
import i18n from "../../../i18n";
import Loader from "../../../components/widgets/loader";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Property Merge",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loader, 
    Button,
    Input,
    Search,
    Area
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "property",
      currency: "",
      breadCrumb: {},
      propertyData: {},
      propertyData2: {},
      valueNotation: '',

      valueProperty1: '',
      valueNetSize1: '',
      valueCrossSize1: '',
      valuePrice1: '',

      valueProperty2: 0,
      valueNetSize2: '',
      valueCrossSize2: '',
      valuePrice2: '',

      valuePropertyNew: '',
      valueNetSizeNew: '',
      valueCrossSizeNew: '',
      valuePriceNew: '',

    };
      
  },
  mounted() {
    
    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 

  },

  methods: {
    loadingData: function(id) {
      // console.log("AAAAAA", id);
      this.fetchingStats = false;
      propertyService.getOne(id)
        .then(response => {
          // console.log(response);

          if(response.data == null) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "property-add"
            });
          }

          this.breadCrumb = {
            text: response.data.code,
            active: true,
          };

          this.fetchingStats = true;
          this.propertyData = response;
          this.valueProperty1 = this.propertyData.data.code;
          this.valueNetSize1 = this.propertyData.data.net_size;
          this.valueCrossSize1 = this.propertyData.data.cross_size;
          this.valuePrice1 = this.propertyData.data.price;
          this.valueNotation = this.propertyData.data.block_note;

          this.loadingPropertyData(this.propertyData.data.projectId, this.propertyData.data.project_floor_id);

          // console.log(this.propertyData.data);
          
        });
    },

    loadingPropertyData: function(projectId = 0, floorId = 0) {

      // console.log(floorId);

      propertyService.getAvailable(projectId, 0, 0, floorId).then(response => {
        this.propertyData2 = response;
      });
    },

    propertyChanged: function(property) {

      propertyService.getOne(property.id)
        .then(response => {

          this.valueProperty2 = response.data.id;
          this.valueNetSize2 = response.data.net_size;
          this.valueCrossSize2 = response.data.cross_size;
          this.valuePrice2 = response.data.price;

          this.valueNetSizeNew = this.valueNetSize1 + this.valueNetSize2;
          this.valueCrossSizeNew = this.valueCrossSize1 + this.valueCrossSize2;
          this.valuePriceNew = this.valuePrice1 + this.valuePrice2;
        
        });  
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "property-list"
          });

        }
      });

      
    },

    submitSave: function() {

      if(this.valueProperty2 == this.$route.params) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('property.merge.property-new') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      } else if(!this.valuePropertyNew) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('property.merge.property-new') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      } else if(!this.valueNetSizeNew) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('property.merge.net-new') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      } else if(!this.valueCrossSizeNew) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('property.merge.size-new') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      } else if(!this.valuePriceNew) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('property.merge.price-new') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      } 


      this.tryingToSubmit = true;

      let obj = {
        merge_with: this.valueProperty2,
        name: this.valuePropertyNew,
        net_size: this.valueNetSizeNew,
        cross_size: this.valueCrossSizeNew,
        price: this.valuePriceNew
      };

      // console.log(JSON.stringify(obj));

      propertyService.merge(this.$route.params.id, obj)
        .then(response => {
        this.tryingToSubmit = false;

        if(response.status == 200) {
          this.$router.push(this.$route.query.redirectFrom || {
            name: "property-list"
          });

          this.$swal.fire({
            title: i18n.t('general.success.title'),
            text: i18n.t('general.success.message-edit'),
            icon: "success",
            confirmButtonText: i18n.t('general.ok')
          });

        }
      });

      
    },

    clearForm: function() {
      this.valueNotation = '';
      this.valueProperty1 = '';
      this.valueNetSize1 = '';
      this.valueCrossSize1 = '';
      this.valuePrice1 = '';
      this.valueProperty2 = 0;
      this.valueNetSize2 = '';
      this.valueCrossSize2 = '';
      this.valuePrice2 = '';
      this.valuePropertyNew = '';
      this.valueNetSizeNew = '';
      this.valueCrossSizeNew = '';
      this.valuePriceNew = '';
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :items="[{
      text: $t('property.merge.text'),
      href: '/general/property',
    }, this.breadCrumb]" :title="$t('property.merge.text') + ' ' + $t('property.text')" />

    <Loader :loading="fetchingStats">
    <div class="row">
      <b-form class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'property1'"
                    :disabled="true"
                    v-model="valueProperty1"
                    :label="'property.merge.property-1'" 
                    :require="true"
                  /> 
                </div>
                <div class="col-md-4">
                  <Search 
                    @change="propertyChanged" 
                    :text="'code'"
                    :id="'property2'"
                    :editable="false"
                    v-model="valueProperty2"
                    :list="this.propertyData2"
                    :label="'property.merge.property-2'" 
                  /> 
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'propertyNew'"
                    v-model="valuePropertyNew"
                    :label="'property.merge.property-new'" 
                  /> 
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'net1'"
                    :disabled="true"
                    v-model="valueNetSize1"
                    :last="'m2'"
                    :label="'property.merge.net-1'" 
                  /> 
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'net2'"
                    :disabled="true"
                    v-model="valueNetSize2"
                    :last="'m2'"
                    :label="'property.merge.net-2'" 
                  /> 
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'number'"
                    :id="'netNew'"
                    v-model="valueNetSizeNew"
                    :last="'m2'"
                    :label="'property.merge.net-new'" 
                  /> 
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'crossSize1'"
                    :disabled="true"
                    v-model="valueCrossSize1"
                    :last="'m2'"
                    :label="'property.merge.size-1'" 
                  /> 
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'crossSize2'"
                    :disabled="true"
                    v-model="valueCrossSize2"
                    :last="'m2'"
                    :label="'property.merge.size-2'" 
                  /> 
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'number'"
                    :id="'crossSizeNew'"
                    v-model="valueCrossSizeNew"
                    :last="'m2'"
                    :label="'property.merge.size-new'" 
                  /> 
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'price1'"
                    :disabled="true"
                    v-model="valuePrice1"
                    :last="'USD'"
                    :label="'property.merge.price-1'" 
                  /> 
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'price2'"
                    :disabled="true"
                    v-model="valuePrice2"
                    :last="'USD'"
                    :label="'property.merge.price-2'" 
                  /> 
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'number'"
                    :id="'price3'"
                    v-model="valuePriceNew"
                    :last="'USD'"
                    :label="'property.merge.price-new'" 
                  /> 
                </div>
              </div>
              
              <div class="row">
                <div class="col-lg-12">
                  <Area 
                    :rows="7"
                    :id="'block_note'"
                    v-model="valueNotation"
                    :label="'property.notation'"  />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">

                  <b-form inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </b-form>
     
                </div>
              </div>
            </div>
          </div>
        </div>

        
      </b-form>
    </div>    
    </Loader>
  </Layout>
</template>